"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Location = void 0;
const tslib_1 = require("tslib");
const Address_1 = require("../commonAttributeSets/Address");
const DefaultContactDetails_1 = require("../commonAttributeSets/DefaultContactDetails");
const GeoModelCommon_1 = require("./GeoModelCommon");
const enumerableDecorator_1 = require("../constructs/enumerableDecorator");
const debug = !process.env.AWS_SESSION_TOKEN && false;
const typeName = 'Location';
class Location extends GeoModelCommon_1.GeoModelCommon {
    constructor(ob) {
        super({ ...ob, type: ob.type ?? typeName });
        this.getGeoCodeableAddress = () => Object.keys(Address_1.Address)
            .map((key) => this[key])
            .filter((entry) => entry)
            .join(',');
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            ...Address_1.Address,
            ...DefaultContactDetails_1.DefaultContactDetails,
        };
    }
}
exports.Location = Location;
tslib_1.__decorate([
    (0, enumerableDecorator_1.enumerable)(false),
    tslib_1.__metadata("design:type", Object)
], Location.prototype, "getGeoCodeableAddress", void 0);
